import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import TippspielWidget from '../TippspielWidget.js';

export default class StartPasswordResetWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}
	
	onLoginReady() {
		Form.onSubmit(this.$widget, action => {
			Ajax.rpc('/start-password-reset', {
				login: action.findField('login').val()
			}, success => {
				if (success) {
					action.$button.remove();
					action.ok('Alles klar. Wir haben dir nun eine Mail an dein Postfach geschickt. Bitte klick dort auf den Link.');
				} else {
					action.error('Hm, ich habe leider weder diesen Namen, noch eine solche Email-Adresse gefunden. Bitte überprüf nochmal deine Eingabe.');
				}
			}, error => {
				MessageUtils.error(this.$widget, TippspielWidget.getFailedMessage(), error);
			});
		});
	}

}
